import React from 'react';
import { Modal, Descriptions, Typography, Tag, Avatar, Divider } from 'antd';
import { BankOutlined, EnvironmentOutlined, IdcardOutlined, UserOutlined, TeamOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const AgencyDetailsModal = ({ open, onClose, data }) => {
  if (!data) return null;

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '16px',
    paddingBottom: '20px',
  };

  const dividerStyle = {
    borderColor: '#e8e8e8',
    color: '#f2654a',
    fontSize: '16px',
    fontWeight: 600,
    marginTop: '8px',
    marginBottom: '20px'
  };

  const sectionStyle = {
    marginBottom: '24px'
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={850}
      centered
      styles={{ body: { padding: '24px 32px 0 32px' } }}
    >
      <div style={headerStyle}>
        <Avatar size={72} style={{ backgroundColor: '#f2654a', fontSize: '28px', fontWeight: 'bold' }}>
          {data.company_name?.charAt(0).toUpperCase()}
        </Avatar>
        <div style={{ flex: 1 }}>
          <Title level={3} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
            {data.company_name}
            <Tag color={data.active ? 'green' : 'red'} style={{ margin: 0, fontSize: '14px', padding: '2px 10px', borderRadius: '4px' }}>
              {data.active ? 'ACTIVE' : 'INACTIVE'}
            </Tag>
          </Title>
          <Text type="secondary" style={{ fontSize: '16px' }}>{data.agency_type_name}</Text>
        </div>
      </div>

      <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '12px', paddingBottom: '24px' }}>
        <div style={sectionStyle}>
          <Divider orientation="left" style={dividerStyle}><BankOutlined /> Overview</Divider>
          <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} size="middle">
            <Descriptions.Item label="Agency Type">{data.agency_type_name || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Line of Business">{data.line_of_business || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Functional Area">{data.functional_area || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Created Date">
              {data.Date ? new Date(data.Date).toLocaleDateString() : 'N/A'}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div style={sectionStyle}>
          <Divider orientation="left" style={dividerStyle}><EnvironmentOutlined /> Location & Contact</Divider>
          <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} size="middle">
            <Descriptions.Item label="Telephone Number" span={2}>{data.telephone_number || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Registered Address" span={2}>{data.registered_address || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Registered City">{data.registered_city || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Operating City">{data.city || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Pin Code">{data.pin_code || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Presence in States" span={2}>{data.presence_in_states || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Operating Cities" span={2}>{data.cities || 'N/A'}</Descriptions.Item>
          </Descriptions>
        </div>

        <div style={sectionStyle}>
          <Divider orientation="left" style={dividerStyle}><IdcardOutlined /> Compliance</Divider>
          <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} size="middle">
            <Descriptions.Item label="PAN No">{data.pan_no || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Service Tax No">{data.service_tax_number || 'N/A'}</Descriptions.Item>
          </Descriptions>
        </div>

        <div style={sectionStyle}>
          <Divider orientation="left" style={dividerStyle}><UserOutlined /> Ownership</Divider>
          <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} size="middle">
            <Descriptions.Item label="Owner Email" span={2}>{data.owner?.email || 'N/A'}</Descriptions.Item>
          </Descriptions>
        </div>

        <div style={sectionStyle}>
          <Divider orientation="left" style={dividerStyle}><TeamOutlined /> Team Summary</Divider>
          <Descriptions bordered column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} size="middle">
            <Descriptions.Item label="Total Users">{data.team_summary?.users || 0}</Descriptions.Item>
            <Descriptions.Item label="Supervisors">{data.team_summary?.supervisors || 0}</Descriptions.Item>
            <Descriptions.Item label="Team Leads">{data.team_summary?.team_leads || 0}</Descriptions.Item>
            <Descriptions.Item label="Telecallers">{data.team_summary?.tele_callers || 0}</Descriptions.Item>
            <Descriptions.Item label="Field Agents">{data.team_summary?.field_agents || 0}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </Modal>
  );
};

export default AgencyDetailsModal;
